export const LANGUAGE = "Accept-Language";
export const AUTH = "Authorization";
export const SKIP_AUTH = "X-Skip-Authorization";